import { getAuth } from "firebase/auth";

export const getCurrentAuthUser = () => {
  const auth = getAuth();
  return auth.currentUser;
};

export const getAuthToken = async ({ forceRefresh = false } = {}) => {
  const currentUser = getCurrentAuthUser();

  if (!currentUser) {
    throw new Error("No user is currently signed in.");
  }

  const token = await currentUser.getIdToken(forceRefresh);
  return token;
};
